/* Project Import will be here */
import {
  applyFilterApi,
  getSchemeProductsApi,
  getOpportunitiesApi,
  getRelevantProductsApi
} from "../services/products";
import Constants from "../utilities/appConstants";
import { initializeOrderState } from "./orders";
import { schemeProductDetailApi } from "services/promotions";
import { ISchemeProductDetailParams } from "models/promotionModels";
import { getErrorObject, normalizeByGroup, mergeMultipleSchemeProducts } from "../utilities/utils";
import { IApplyFilterParams, ISchemeProductParams } from "models/productModels";
import { IBannerDetailsParams } from "models/homeModels";
import { getBannerViewApi } from "services/home";
import { navigateToProductList } from "app/navigation";
/* Project Import will be here */

export const types = {
  PRODUCTS_REQUEST: "products/PRODUCTS_REQUEST",
  PRODUCTS_SUCCESS: "products/PRODUCTS_SUCCESS",
  PRODUCTS_FAILURE: "products/PRODUCTS_FAILURE",
  INITIALIZE_FILTER: "products/INITIALIZE_FILTER",
  NEXT_PAGE_REQUEST: "products/NEXT_PAGE_REQUEST",
  BANNER_REQUEST: "products/BANNER_REQUEST",
  PRODUCT_UPDATE_IS_FAV: "products/PRODUCT_UPDATE_IS_FAV",
  IS_SHOW_SHOW_MORE_PRODUCT_BUTTON: "products/IS_SHOW_SHOW_MORE_PRODUCT_BUTTON",
  UPDATE_SUGGESTED_ORDER_VALUE: "products/UPDATE_SUGGESTED_ORDER_VALUE"
};

/* Initial product filter state values */
export const initialFilterState = {
  page: 1,
  CAT: {
    FilterLevelCode: "CAT",
    FilterIdList: []
  },
  SUCAT: {
    FilterLevelCode: "SUCAT",
    FilterIdList: []
  },
  BR: {
    FilterLevelCode: "BR",
    FilterIdList: []
  },
  NeedScheme: false,
  NeedPastPurchase: false,
  applied: "",
  NeedFavourite: false,
  IsShowShowMoreProductButton: true,
  Sorting: Constants.PRICE_ASC,
  NeedRecommended: false,
  AttrFilter: [],
  NeedFOC: false
};

const initialState = {
  filter: initialFilterState,
  groupIds: [],
  group: {},
  isLoading: false,
  ids: [],
  data: {},
  count: 0,
  totalCount: 0,
  suggestedOrderValue: 0,
  noOfItemsReceived: 0,
  error: null
};

export const products = (state = initialState, action) => {
  switch (action.type) {
    case types.PRODUCTS_REQUEST: {
      return {
        ...initialState,
        filter: {
          ...state.filter,
          ...action.payload.filter,
          IsShowShowMoreProductButton: true
        },
        isLoading: true
      };
    }

    case types.PRODUCTS_SUCCESS:
      return {
        ...state,
        ...action.payload,
        filter: {
          ...state.filter
        },
        error: null,
        isLoading: false
      };

    case types.NEXT_PAGE_REQUEST:
      return {
        ...state,
        filter: {
          ...state.filter,
          page: action.payload.nextPage
        },
        error: null,
        isLoading: true
      };

    case types.IS_SHOW_SHOW_MORE_PRODUCT_BUTTON:
      return {
        ...state,
        filter: {
          ...state.filter,
          IsShowShowMoreProductButton: action.payload
        },
        error: null
      };

    case types.PRODUCTS_FAILURE:
      return {
        ...state,
        filter: state.filter,
        isLoading: false,
        error: action.payload.error
      };

    case types.INITIALIZE_FILTER: {
      const { code, FilterIdList } = action.payload;
      return {
        ...state,
        filter: {
          ...state.filter,
          [code]: { ...state.filter[code], FilterIdList }
        }
      };
    }

    case types.UPDATE_SUGGESTED_ORDER_VALUE: {
      return {
        ...state,
        suggestedOrderValue: action.payload.suggestedOrderValue
      };
    }

    case types.PRODUCT_UPDATE_IS_FAV:
      let { ProductId, IsFavourite } = action.payload;
      if (ProductId in state.data) {
        return {
          ...state,
          data: { ...state.data, [ProductId]: { ...state.data[ProductId], IsFavourite: IsFavourite === 0 ? 1 : 0 } },
          filter: {
            ...state.filter
          },
          error: null,
          isLoading: false
        };
      }
      else {
        return state;
      }
    default:
      return state;
  }
};

export const applyFilter = (data: IApplyFilterParams) => {
  return async (dispatch, getState) => {
    /* Extract the data object */
    let { NeedFavourite, FilterLevelCode, FilterIdList, NeedScheme, NeedOpportunity, NeedRelevant, NeedRecommended } = data;

    const attrFilterState = getState().attrFilter;
    const commonState = getState().common;

    /* Get the initial state filter */
    let productFilterState = getState().products.filter;
    productFilterState = {
      ...initialFilterState,
      NeedFOC: commonState.isFocSelected,
      NeedScheme: NeedScheme,
      NeedOpportunity: NeedOpportunity,
      NeedRelevant: NeedRelevant,
      Sorting: attrFilterState.selectedSortingFilter,
      AttrFilter: attrFilterState.selectedAttrFilter,
      NeedRecommended: NeedRecommended
    };

    if (NeedFavourite) {
      productFilterState.NeedFavourite = NeedFavourite;
    }
    else {
      /* Convert filter id into int */
      FilterIdList = [parseInt(FilterIdList, 10)];

      if (FilterLevelCode === "CAT")
        productFilterState.CAT = { FilterLevelCode, FilterIdList };
      else if (FilterLevelCode === "SUCAT")
        productFilterState.SUCAT = { FilterLevelCode, FilterIdList };
    }

    /* Initialize the product request */
    dispatch({ type: types.PRODUCTS_REQUEST, payload: { filter: productFilterState } });

    /* Check for Opportunity page, If it is the opportunity page will call the getOpportunitiesApi */
    if (productFilterState.NeedOpportunity)
      getOpportunitiesProducts({ getState, dispatch });
    else if (productFilterState.NeedRelevant)
      getRelevantProducts({ getState, dispatch });
    else
      getProductsAPI({ getState, dispatch });
  }
};

/* Get product list based on the applied filer conditions */
const getProductsAPI = async ({ getState, dispatch }) => {
  try {
    /* Get applied filter */
    const filterToApply = filterMiddleWare(getState().products.filter, getState().attrFilter);

    /* Make API call to fetch the products */
    const response = await applyFilterApi(filterToApply);

    /* Merge the same product with multiple scheme and normalize the products */
    dispatch(mergeAndNormalizeProducts(response.data.Data, response.data.Count, response.data.TotalCount));
  }
  catch (error) {
    dispatch(promiseCatchBlock(error, types.PRODUCTS_FAILURE));
  }
};

export const getSchemeProducts = (data: ISchemeProductParams) => {
  return async (dispatch, getState) => {
    dispatch({
      type: types.PRODUCTS_REQUEST,
      payload: { filter: { ...initialFilterState, ...data } }
    });
    try {
      /* Get applied filter */
      const filterToApply = filterMiddleWare(getState().products.filter, getState().attrFilter);

      /* Hit the getSchemeProductsApi to fetch the only scheme products */
      const response = await getSchemeProductsApi(filterToApply);

      /* Merge the same product with multiple scheme and normalize the products */
      dispatch(mergeAndNormalizeProducts(response.data.Data, response.data.Count, response.data.TotalCount));
    }
    catch (error) {
      dispatch(promiseCatchBlock(error, types.PRODUCTS_FAILURE));
    }
  };
};

/* Handle Opportunities get functionality */
export const getOpportunitiesProducts = async ({ getState, dispatch }) => {
  try {
    const filterToApply = filterMiddleWare(getState().products.filter, getState().attrFilter);

    /* Hit the getOpportunitiesApi to fetch the only opportunity products */
    const response = await getOpportunitiesApi(filterToApply);

    /* Merge the same product with multiple scheme and normalize the products */
    dispatch(mergeAndNormalizeProducts(response.data.Data, response.data.Count, response.data.TotalCount));
  }
  catch (error) {
    dispatch(promiseCatchBlock(error, types.PRODUCTS_FAILURE));
  }
};

/* Handle Relevant get functionality */
export const getRelevantProducts = async ({ getState, dispatch }) => {
  try {
    const filterToApply = filterMiddleWare(getState().products.filter, getState().attrFilter);

    /* Hit the getRelevantProductsApi to fetch the only relevant products */
    const response = await getRelevantProductsApi(filterToApply);

    /* Update suggested order value */
    dispatch({
      type: types.UPDATE_SUGGESTED_ORDER_VALUE,
      payload: { suggestedOrderValue: response.data.SuggestedOrderValue }
    });

    /* Merge the same product with multiple scheme and normalize the products */
    dispatch(mergeAndNormalizeProducts(response.data.Data, response.data.Count, response.data.TotalCount));
  }
  catch (error) {
    dispatch(promiseCatchBlock(error, types.PRODUCTS_FAILURE));
  }
};

/* Product pagination */
export const getNextPage = (nextPage, tabType, pageType) => {
  return async (dispatch, getState) => {
    /* Update the next page number before API request */
    dispatch({ type: types.NEXT_PAGE_REQUEST, payload: { nextPage } });

    try {
      const filters = getState().products.filter;
      const filterToApply = filterMiddleWare(filters, getState().attrFilter);

      let response = null;
      /* If - Call the appropriate API based on the tab type */
      if (pageType === null) {
        if (tabType === Constants.SCHEME) {
          filterToApply.NeedScheme = true;
          response = await getSchemeProductsApi(filterToApply);
        }
        else if (tabType === Constants.OPPORTUNITY) {
          response = await getOpportunitiesApi(filterToApply);
        }
        else if (tabType === Constants.RELEVANT) {
          response = await getRelevantProductsApi(filterToApply);
        }
        else {
          response = await applyFilterApi(filterToApply);
        }
      }
      /* Else - Call the appropriate API based of the screen type */
      else {
        /* Home page section hot deals and best selling */
        if (pageType === Constants.PAGE_TYPE_HOT_DEALS || pageType === Constants.PAGE_TYPE_BEST_SELLING_PRODUCTS) {
          filterToApply.NeedScheme = true;
          response = await getSchemeProductsApi(filterToApply);
        }
        /* Home page section recommended */
        else if (pageType === Constants.PAGE_TYPE_RECOMMENDED) {
          filterToApply.NeedRecommended = true;
          response = await applyFilterApi(filterToApply);
        }
        /* Scheme details page */
        else if (pageType === Constants.SCHEME_DETAILS) {
          const selectedPromotion = getState().promotions.selectedPromotionDetails;
          const requestObject: ISchemeProductDetailParams = {
            Ids: [selectedPromotion.Scheme[0].Id],
            NeedProduct: true,
            Sorting: getState().appSettings.defaultProductSorting,
            Page: filterToApply.page
          };

          response = await schemeProductDetailApi(requestObject);
          response.data.Count = response.data.Data.Count;
          response.data.TotalCount = response.data.Data.TotalCount;
          response.data.Data = response.data.Data.Products;
        }
        /* Home page section banner details page */
        else if (pageType === Constants.BANNER_DETAILS) {
          const selectedBanner = getState().banners.bannerDetails;
          const requestParam: IBannerDetailsParams = {
            Page: filterToApply.page,
            Sorting: getState().appSettings.defaultProductSorting,
            FilterLevelCode: "SKU",
            FilterIdList: [selectedBanner.Banners[0].Id]
          };

          response = await getBannerViewApi(requestParam);
          response.data.Data = response.data.Data.Products;
        }
      }

      /* Hide show more button when no products is returned by the API */
      if (response.data.Data.length === 0) {
        dispatch({
          type: types.IS_SHOW_SHOW_MORE_PRODUCT_BUTTON,
          payload: false
        });
        dispatch({ type: types.PRODUCTS_FAILURE, payload: { error: "" } });
      }

      /* Merge the same product with multiple scheme and normalize the products */
      dispatch(mergeAndNormalizeProducts(response.data.Data, response.data.Count, response.data.TotalCount, true));
    }
    catch (error) {
      dispatch({
        type: types.IS_SHOW_SHOW_MORE_PRODUCT_BUTTON,
        payload: false
      });
      dispatch(promiseCatchBlock(error, types.PRODUCTS_FAILURE));
    }
  };
};

/* Merge the same product with multiple scheme and normalize the products */
export const mergeAndNormalizeProducts = (products, productCount, totalCount, isFromNexPage = false) => {
  return async (dispatch, getState) => {
    /* Merge the multi scheme products */
    const productList = mergeMultipleSchemeProducts(products);

    let payload = normalizeByGroup({
      data: productList,
      key: "ProductId",
      groupKey: "GroupId"
    });

    /* if isFromNexPage is true, Attach the next page products to the previous page products */
    if (isFromNexPage) {
      /* If no data available for the next page.no need to do anything */
      if (productList.length > 0) {
        const oldProducts = getState().products;
        const newState = {
          groupIds: [...oldProducts.groupIds, ...payload.groupIds],
          group: { ...oldProducts.group, ...payload.group },
          ids: [...oldProducts.ids, ...payload.ids],
          data: { ...oldProducts.data, ...payload.data }
        };
        newState.count = productCount;
        newState.totalCount = totalCount;
        newState.noOfItemsReceived = oldProducts.noOfItemsReceived + products.length;

        dispatch({ type: types.PRODUCTS_SUCCESS, payload: newState });
      }
    }
    /* Else add only the new products */
    else {
      payload.count = productCount;
      payload.totalCount = totalCount;
      payload.noOfItemsReceived = products.length;

      dispatch({ type: types.PRODUCTS_SUCCESS, payload });
    }

    /* Initialize the Apply filter products into the order reducer */
    await dispatch(initializeOrderState());
  };
};

const filterMiddleWare = (filters, attrFilter) => {
  let reqObj = {
    page: filters.page,
    NeedScheme: filters.NeedScheme,
    NeedPastPurchase: filters.NeedPastPurchase,
    NeedRecommended: filters.NeedRecommended,
    NeedFavourite: filters.NeedFavourite,
    Sorting: filters.Sorting,
    AttrFilter: filters.AttrFilter,
    NeedFOC: filters.NeedFOC
  };

  /* Spread the CAT, SUCAT, BR object */
  for (let i = 0; i < Constants.filterOrder.length; i++) {
    const key = Constants.filterOrder[i];

    if (filters[key].FilterIdList.length !== 0) {
      if (filters[key].FilterIdList[0]) {
        reqObj = { ...reqObj, ...filters[key] };
      }
    }
  }

  return reqObj;
};

/* Initialize filter */
export const initializeFilter = ({ code, id }) => {
  return {
    type: types.INITIALIZE_FILTER,
    payload: { code, FilterIdList: [id] }
  };
};

/* Apply product attribute filter */
export const applyAttributeFilter = () => {
  return async (dispatch, getState) => {
    /* Get attr filter state */
    const attrFilter = getState().attrFilter;

    /* Get current landed tab */
    const landedTab = getState().common.productTab;

    /* Get product filter state */
    let filterObj = getState().products.filter;

    /* Update the product filter state based on attr filter state */
    filterObj.page = 1;
    filterObj.AttrFilter = attrFilter.selectedAttrFilter;
    filterObj.Sorting = attrFilter.selectedSortingFilter;

    /* Dispatch the updated state */
    dispatch({ type: types.PRODUCTS_REQUEST, payload: { filter: filterObj } });

    /* Call the appropriate action method based on tab type */
    if (landedTab === Constants.OPPORTUNITY)
      getOpportunitiesProducts({ getState, dispatch });
    else if (landedTab === Constants.RELEVANT)
      getRelevantProducts({ getState, dispatch });
    else
      getProductsAPI({ getState, dispatch });
  };
};

/* Generic code for promise catch block */
const promiseCatchBlock = (error: any, type: string) => {
  return (dispatch) => {
    const { message, errorCode } = getErrorObject(error);
    dispatch({
      type: type,
      payload: { error: message }
    });

    /*If errorcode is no data found we are checking cat sucat mapping*/
    if (errorCode === Constants.RA_NO_DATA)
      dispatch(checkWrongCatSucatMapping(errorCode));
  }
};

/*When category and subcategory is not mapped to the distributor, We are redirecting to the product list page*/
const checkWrongCatSucatMapping = (errorCode) => {
  return (dispatch, getState) => {
    const productReducer = getState().products;
    const catReducer = getState().categoryMenu;

    if (productReducer.filter.CAT.FilterIdList.length > 0 && !catReducer.CAT.ids.includes(parseInt(productReducer.filter.CAT.FilterIdList[0], 10)))
      dispatch(navigateToProductList());
    else if (productReducer.filter.SUCAT.FilterIdList.length > 0 && !catReducer.SUCAT.ids.includes(parseInt(productReducer.filter.SUCAT.FilterIdList[0], 10)))
      dispatch(navigateToProductList());
  }
}